import { W2InterestDialogProps } from './interface';
import React from 'react';
import { W2InterestFormFields } from './W2InterestFormFields';
import { Button, BottomSheetModal } from '@medely/ui-kit';
import { useW2Interest } from '@mp/hooks/useW2Interest';
import { useW2interestEvent } from '@mp/hooks';
import { useWatch } from '@medely/ui-kit/react-hook-form';

export const W2InterestDialog = ({ open, onClose }: W2InterestDialogProps) => {
  const { setW2Interest, isLoading: isW2Loading } = useW2Interest();
  const { trackW2InterestCardClick } = useW2interestEvent();

  const value = useWatch({ name: 'w2_interest' });

  const handleSave = () => {
    trackW2InterestCardClick();
    setW2Interest(value === 1 ? true : false);
    onClose();
  };

  return (
    <BottomSheetModal
      isOpen={open}
      onClose={onClose}
      title="W-2 interest"
      showDragIndicator={false}
      actions={
        <Button disabled={isW2Loading} loading={isW2Loading} fullWidth onClick={handleSave}>
          Save
        </Button>
      }
    >
      <W2InterestFormFields />
    </BottomSheetModal>
  );
};
